import React from 'react'

export function isElement(element: React.ReactNode): element is React.ReactElement {
    if (Array.isArray(element)) {
        return false
    }

    return !!(typeof element === 'object' && element !== null && Reflect.get(element, 'type') !== React.Fragment)
}
